import React, {
  useRef,
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel"; // 조회조건 Panel
import { fnGetDataSet, fnSave } from "@shared/api/restApi"; // BackEnd API
import {
  getCodeData,
  getInitFormData,
  getNoSlip,
  applySlip,
  CalAm,
  setUmByFgUm,
} from "@shared/utils/CommonUtils"; // 공통 유틸 메뉴 초기화(조회조건, 그리드, 프리폼) 설정 load 관련 내용
import { showDialog } from "@widgets/CommonDialog"; // Message Box
import { global } from "@shared/libs/Global"; // Login User관련 전역 변수( 로그인 정보)
import SnGrid from "@shared/components/GridV2/SnGrid"; // 공통 그리드
import { menuInfo, ValueChangedEvent } from "@shared/type/CommonType"; // 공통 Interface
import { showPopupModal } from "@widgets/CommonModal";
import SnButton from "@shared/components/SnButton";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import axios from "axios";
import { RowNode } from "ag-grid-community/dist/types/src/entities/rowNode";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import { add } from "date-fns";
import { Key } from "@mui/icons-material";
interface Props {
  Menuprops: menuInfo;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_PMS_PJT_REG_015 = forwardRef(({ Menuprops }: Props, ref) => {
  //#region  variable
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
  });
  const searchRef = useRef<any>(null);
  const today = new Date();
  const todayform = `${today.getFullYear()}${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${today.getDate().toString().padStart(2, "0")}`;
  const { userInfo } = global(); // Login user 정보
  //#endregion

  //#region  Components useState
  const [formData, setFormData] = useState<any>(); // 조회조건 변수
  const [formControlData, setFormControlData] = useState<any[]>([]); // 조회조건 설정된 항목 binding
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
  });
  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const addFlag = useRef<any>(false);
  //#endregion

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData({});
        setFormControlData(rtn.formControlData); // 조회조건 항목 설정
        setFormData(rtn.formData); // 조회조건 초기값
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  //#region  Button Event
  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL = gridRefs.current["grid2"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        await onSave();
      }
    }
    try {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      const searchInfo = searchRef.current.getFormdata();
      if (searchInfo.cd_pjt == null || searchInfo.cd_pjt == "") {
        showDialog("alter", "프로젝트를 선택해주세요.");
        return;
      }
      const params = {
        id: "sn_pms_pjt_reg_015_01",
        params: searchRef.current.getFormdata(),
      };
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1],
      });
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onInsert = async () => {
    try {
      const searchInfo = searchRef.current.getFormdata();
      if (searchInfo.cd_pjt == null || searchInfo.cd_pjt == "") {
        showDialog("alter", "프로젝트를 선택해주세요.");
        return;
      }
      const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
      if (modifiedRowsH.modifiedRowcount > 0) {
        showDialog("alter", "수정된 내용이 있습니다.");
        return;
      }

      gridRefs.current["grid1"].current.forEachNode((node: any) => {
        if (node.data) {
          node.setDataValue("st_budget", "C", "noEvent");
        }
      });

      const maxNoHst = gridRefs.current["grid1"].current.getMaxValue("no_hst");
      const newRow = {
        cd_firm: userInfo.cd_firm,
        cd_pjt: searchInfo.cd_pjt,
        no_hst: maxNoHst + 1,
        cd_emp: userInfo.cd_emp,
        nm_emp: userInfo.nm_emp,
        dt_budget: todayform,
        st_budget: "F",
      };
      gridRefs.current["grid1"].current.addRow(newRow);

      const prevNoHst = maxNoHst;
      const rowDataL: any[] = [];

      gridRefs.current["grid2"].current.forEachNode((node: any) => {
        if (node.data.no_hst === prevNoHst) {
          rowDataL.push(node.data);
        }
      });

      const newNoHst = maxNoHst + 1;
      if (newNoHst !== 1) {
        addFlag.current = true;
        const newRows = rowDataL.map((row: any, idx: number) => ({
          ...row,
          no_hst: newNoHst,
          no_line: row.no_line,
          KeyField: null,
        }));
        newRows.forEach((row) => {
          gridRefs.current["grid2"].current.addRow(row);
        });
        addFlag.current = false;
      }
    } catch (error: any) {
      showDialog("error", error.message);
    }
  };

  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) return;

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;

    gridRefs.current["grid2"].current.deleteAllRows();
    gridRefs.current["grid1"].current.deleteSelectedRows();

    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return;
    }

    return await onSave();
  };

  const onAddRow = () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();

      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (!focusedNodeH) {
        alert("선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      return gridRefs.current["grid2"].current?.addRow({});
    } catch (error: any) {}
  };

  const onBeforeAddRowL = () => {
    try {
      if (addFlag.current) {
        return {};
      } else {
        const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
        const maxNoLine =
          gridRefs.current["grid2"].current.getMaxValue("no_line");

        return {
          cd_firm: userInfo.cd_firm,
          cd_pjt: focusedNodeH.data?.cd_pjt,
          no_hst: focusedNodeH.data?.no_hst,
          no_line: maxNoLine + 1,
          qt: 0,
          um: 0,
          am: 0,
          qt_labor: 0,
        };
      }
    } catch (error: any) {
      return false;
    }
  };

  const onDeleteRow = async () => {
    if (gridRefs.current["grid2"].current?.getDisplayedRowCount() < 1) return;

    gridRefs.current["grid2"].current?.deleteSelectedRows();
  };

  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      gridRefs.current["grid2"].current?.stopEditing();

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) {
        return false;
      }

      const requiredValuesCheckL =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckL) {
        return false;
      }

      const prdwmohChange = gridRefs.current["grid1"].current.getChange();
      const prdwmolChange = gridRefs.current["grid2"].current.getChange();
      const headerInserts = prdwmohChange.insert ?? [];
      const lineInserts = prdwmolChange.insert ?? [];
      if (headerInserts > 0 && lineInserts.length === 0) {
        await showDialog("alter", "저장에 실패했습니다.");
        return false;
      }

      if (
        prdwmohChange.modifiedRowcount === 0 &&
        prdwmolChange.modifiedRowcount === 0
      ) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      const SaveData = {
        budgeth: prdwmohChange,
        budgetl: prdwmolChange,
      };

      const ok = await fnSave("SN_PMS_PJT_REG_015_SAVE_01", SaveData);
      if (!ok) {
        gridRefs.current["grid2"].current.forEachNode((node: RowNode) => {});
        return false;
      }
      // 성공적으로 저장된 후 초기화
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      return false;
    }
  };
  //#endregion

  //#region  Event Method
  const onGrid2BtnsClick = async (id: string) => {
    if (id === "addRow") {
      onAddRow();
    }

    if (id === "deleteRow") {
      onDeleteRow();
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const cd_pjt = selectedRow.cd_pjt;
      const no_hst = selectedRow.no_hst;
      setSelectedDocu(cd_pjt);
      gridRefs.current["grid2"].current.applyFilters({ no_hst: no_hst });
      console.log("=== 필터 적용된 grid2 데이터 ===");
      gridRefs.current["grid2"].current.forEachFilteredNode((node: any) => {
        console.log(node.data);
      });
      gridRefs.current["grid2"].current.selectAndFocusRow(0);
    } else {
      return;
    }
  };

  const onSearchPanelValueChanged = async (event: ValueChangedEvent) => {
    const { colId, rowData } = event;

    switch (colId) {
      case "cd_pjt":
        const searchInfo = searchRef.current.getFormdata();

        const param = {
          cd_firm: userInfo.cd_firm,
          cd_pjt: searchInfo.cd_pjt,
        };

        try {
          const params = {
            id: "sn_pms_pjt_reg_015_02",
            params: {
              cd_firm: userInfo.cd_firm,
              cd_pjt: searchInfo.cd_pjt,
            },
          };
          const data: any = await fnGetDataSet(params);

          if (data && data.length > 0) {
            rowData.fg_pjt = data[0][0].fg_pjt;
            rowData.dt_start = data[0][0].dt_start;
            rowData.dt_end = data[0][0].dt_end;
            rowData.am_k = data[0][0].am_k;
          }
        } catch (e) {
          console.error(e);
        }
        break;
    }
  };

  const onCellValueChanged = async (event: CellValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    const focusedRowNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    if (colId === "cd_cust") {
      const rowCount = gridRefs.current["grid2"].current.getDisplayedRowCount();
      if (rowCount === 1) return;
      if (!rowData.cd_cust) return;

      let apply = false;
      gridRefs.current["grid2"].current?.forEachFilteredNode(
        (node: RowNode) => {
          if (
            node.data[colId] === "" ||
            node.data[colId] === null ||
            node.data[colId] === undefined
          )
            apply = true;
        }
      );
      if (!apply) return;

      const confirm = await showDialog(
        "confirm",
        "일괄적용하시겠습니까?(비어있는 칸이 채워집니다.)"
      );
      const updatedNodes: RowNode[] = [];
      if (confirm) {
        gridRefs.current["grid2"].current?.forEachFilteredNode(
          (node: RowNode) => {
            if (
              node.data.cd_cust === "" ||
              node.data.cd_cust === null ||
              node.data.cd_cust === undefined
            ) {
              node.setDataValue("cd_cust", rowData.cd_cust);
              node.setDataValue("nm_cust", rowData.nm_cust);
              node.setDataValue("nm_cust_sort", rowData.nm_cust_sort);
              updatedNodes.push(node);
            }
          }
        );
        gridRefs.current["grid2"].current.stopEditing();
      }
      await setUmByFgUm(
        gridRefs.current["grid1"],
        gridRefs.current["grid2"],
        "dt_app",
        rowData.tp_um,
        updatedNodes
      );
    }

    CalAm(gridRefs.current["grid1"], gridRefs.current["grid2"], colId);
  };
  //#endregion

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onBtnAddClick: onGrid2BtnsClick,
          onBtnDeleteClick: onGrid2BtnsClick,
          onBeforeAddRow: onBeforeAddRowL,
          onCellValueChanged: onCellValueChanged,
        },
      },
    }),
    [columns, dataSources]
  );

  //#region  UI
  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
          onValueChanged={onSearchPanelValueChanged}
        ></SearchPanel>
      </div>
      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="29.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]} // Grid Name
            columnConfig={grids.grid1.columns} // 컬럼 설정 전달
            rowData={grids.grid1.dataSource} // Datasource
            etcProps={{ rowSelection: "single", title: "예산정보" }}
            events={grids.grid1.events}
            filter={{
              refs: [gridRefs.current["grid2"]],
              columns: ["no_hst"],
            }}
          />
        </SnResizeBar>

        <SnResizeBar direction={"height"} id="panel2" orgSize="71.5%">
          <SnGrid
            ref={gridRefs.current["grid2"]} // Grid Name
            columnConfig={grids.grid2.columns} // 컬럼 설정 전달
            rowData={grids.grid2.dataSource} // Datasource
            etcProps={{ rowSelection: "multiple", title: "상세정보" }}
            events={grids.grid2.events}
          />
        </SnResizeBar>
        <SnFileUploadBox selectedDocu={selectedDocu} selectedLineDocu={0} />
      </div>
    </div>
  );
  //#endregion
});

export default SN_PMS_PJT_REG_015;
